import React from 'react';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import {UseQueryResult} from '@tanstack/react-query';
import {FormModelHttpResponse} from '../../../@types/components/Form';
import {Props} from '../../_forms/FormViewForm';
import {IFormDataProviderAPIContext} from '../../../@interfaces/contexts/IFormDataProviderAPIContext';
import {FormDataProviderAPIContext} from '../../../contexts/FormDataProviderAPIContext';

export default function FormRemoteDataManager<Model extends IEmptyModel = IEmptyModel>(props: {
    queryApi: UseQueryResult<FormModelHttpResponse<Model>, Error>,
    componentToRender: React.ComponentType<Props<Model>>
} & Props<Model>) {
    // eslint-disable-next-line
    const {queryApi, componentToRender, ...rest} = props;
    const Component = componentToRender;

    // TODO: provide ability to replace some props of Component to manipulate server side data

    const contextValue: IFormDataProviderAPIContext<Model> = {
        context: props.context,
        formName: props.formName,
        config: props.config,
        model: props.model,
        modelOptions: props.modelOptions,
    };

    return <FormDataProviderAPIContext.Provider value={contextValue}>
        <Component {...rest}/>
    </FormDataProviderAPIContext.Provider>;
}
